import PropTypes from "prop-types";
import React from "react";

export default function TextHeader(props) {
    if(props.field && props.field.length > 0){
        const additionalStyles = props.styleClass ? props.styleClass : "";
        return (
            <div className={`fieldText ${additionalStyles}`}>
                {props.field} 
            </div>
        );
    }
    else {
        return (
            <div className={`fieldText placeholder ${props.styleClass}`}>
                {props.placeholder}
            </div>
        );            
    }
}

TextHeader.propTypes = {
    field: PropTypes.string,
    placeholder: PropTypes.string,
    styleClass: PropTypes.string
};

